<template>
  <div class="guard-container">
    <sn-illustration
      illustration="NetworkError"
      class="mb-6 guard-icon"
      size="xl"
    />

    <div class="guard-header mb-3">
      <span>{{ header }}</span>
    </div>

    <div class="guard-subtext mb-6">
      <span>Contact your admin or please submit a <a href= 'https://mortgagehelp.ncino.com/hc/en-us' style="color: inherit;">support ticket</a> for more details.</span>
    </div>
  </div>
</template>

<script>

export default {
  name: 'NoAccess',
  computed: {
    header () {
      if (this.$route.path.includes('company_locked')) {
        return 'This company is locked'
      } else if (this.$route.path.includes('user_locked')) {
        return 'Your account is locked'
      } else if (this.$route.path.includes('company_inactive')) {
        return 'This company is no longer active'
      } else if (this.$route.path.includes('user_inactive')) {
        return 'This user is no longer active'
      } else if (this.$route.path.includes('no_permissions')) {
        return 'You have no permissions'
      } else {
        return 'Page not found'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~/assets/css/snui/index.scss';

.guard-container {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.guard-icon {
  margin-top: 150px;
}

.guard-header {
  font-family: $font-family-secondary;
  font-size: 28px;
  font-weight: $font-weight-bold;
  line-height: 36px;
}

.guard-subtext {
  font-family: $font-family-primary;
  font-size: 17px;
  font-weight: $font-weight-regular;
  line-height: 24px;
}
</style>
